/** The deal-call stage when no bank drew an offer: the question for the room, and what each bank stood at on its own (its share price at the last played year-end). */
import type { FinaleReplay } from "@bsim/contracts";
import { formatUsdAShare } from "../format";
import { NO_OFFER_QUESTION } from "./labels";

export function NoOffer({ replay, testId }: { readonly replay: FinaleReplay | null; readonly testId: string }) {
  const rows = (replay?.seats ?? []).flatMap((s) => { const last = s.priceUsdPerShareByYear?.at(-1); return last === undefined ? [] : [{ teamId: s.teamId, name: s.name, price: last }]; });
  return (
    <div data-testid={testId}>
      <p className="gx-room-prompt gx-room-prompt--centre">{NO_OFFER_QUESTION}</p>
      {rows.length === 0 ? null : (
        <>
          <p className="gx-small gx-muted">Each bank on its own, at the close of the last year played:</p>
          <ul className="gx-room-cards gx-fac-list" data-testid={`${testId}.standalone`}>{rows.map((r) => <li key={r.teamId}><b>{r.name}</b><span className="gx-num">{formatUsdAShare(r.price)}</span></li>)}</ul>
        </>
      )}
    </div>
  );
}
